import { resolveI18n } from "../../commons/services/Translation";

// 프로젝트 하위 리스트의 테이블 컬럼 width를 분기처리
export const MainTableWidth = (i18n) => {
  
  return {
    plant: [ // plant list table header width
      resolveI18n({ i18n, ko: "6%", en: "6%", vi: "8%" }), // 첫번째 컬럼
      resolveI18n({ i18n, ko: "64%", en: "64%", vi: "62%" }), // 두번째 컬럼
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" }), // 세번째 컬럼
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" })  // 네번째 컬럼
    ],
    device: [
      resolveI18n({ i18n, ko: "6%", en: "6%", vi: "8%" }),
      resolveI18n({ i18n, ko: "12%", en: "12%", vi: "12%" }),
      resolveI18n({ i18n, ko: "21%", en: "21%", vi: "19%" }),
      resolveI18n({ i18n, ko: "10%", en: "10%", vi: "10%" }),
      resolveI18n({ i18n, ko: "12%", en: "12%", vi: "12%" }),
      resolveI18n({ i18n, ko: "12%", en: "12%", vi: "12%" }),
      resolveI18n({ i18n, ko: "12%", en: "12%", vi: "12%" }),
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" })
    ],
    battery: [
      resolveI18n({ i18n, ko: "6%", en: "6%", vi: "8%" }),
      resolveI18n({ i18n, ko: "49%", en: "49%", vi: "47%" }),
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" }),
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" }),
      resolveI18n({ i18n, ko: "15%", en: "15%", vi: "15%" })
    ]
  }
}

// DrawingModule Modal 언어별 스타일
export const DrawingModuleModal = (i18n) => {
  return {
    labelWidthClass: resolveI18n({ i18n, ko: "w60", en: "w120", vi: "w100" }), 
  }
}

// Equip 언어별 스타일
export const EquipInputLabelClass = (i18n) => {
  return resolveI18n({ i18n, ko: "w120", en: "w180", vi: "w200" })
}